import { Big } from 'big.js';
import { TenantJobLine } from '~/lib/model';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import MpiTourConfig from '~/tenants/mpi/performable/tour/MpiTourConfig';
import MpiPhotosConfig from '~/tenants/mpi/performable/photos/MpiPhotosConfig';
import MpiAerialConfig from '~/tenants/mpi/performable/aerial/MpiAerialConfig';
import Mpi3dConfig from '~/tenants/mpi/performable/3d/Mpi3dConfig';
import MpiJob from '~/tenants/mpi/model/MpiJob';

export default class MpiTourJob extends MpiJob<typeof MpiTourConfig> {
  get performable(): typeof MpiTourConfig {
    return MpiTourConfig;
  }

  get dependencies(): string[] {
    return [MpiPhotosConfig.id, MpiAerialConfig.id, Mpi3dConfig.id];
  }

  get assignable() {
    return true;
  }

  defaultValue(): ZodVersionedMetadata<(typeof MpiTourConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
    };
  }

  revenueLines(): TenantJobLine[] {
    const lines = super.revenueLines();

    lines.push({
      id: 'tour',
      description: 'Virtual Tour',
      amount: new Big('50'),
    });

    return lines;
  }
}
